var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-btn",on:{"click":function($event){return _vm.$emit('click')}}},[_c('inline-svg',{staticClass:"arrow",attrs:{"src":require('@/assets/img/back_bt_arrow.svg')}}),_c('span',[_vm._v("Back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }